import dialogPolyfill from 'dialog-polyfill'

const hasHTMLDialogElement = !!window.HTMLDialogElement
const enablePolyfillHTMLDialogElement = !hasHTMLDialogElement

function handleErrorCloseDialogElement(error) {
  console.log('Error close polyfill:', error)
}

// Polyfill for direct createElement api.
document.createElement = (function (create) {
  return function () {
    var ret = create.apply(this, arguments)
    if (enablePolyfillHTMLDialogElement && ret.tagName.toLowerCase() === 'dialog') {
      dialogPolyfill.forceRegisterDialog(ret)
      ret.close = () => {
        try {
          ret.close()
        } catch (error) {
          handleErrorCloseDialogElement(error)
        }
      }
    }
    return ret
  }
})(document.createElement)

// Polyfill for class HTMLDialogElemnt.
class HTMLDialogElement extends HTMLElement {
  constructor() {
    super()

    // Hack for the polyfill
    this.showModal = undefined

    // Actual polyfill
    dialogPolyfill.forceRegisterDialog(this)

    // Use `Object.assign` for cleaner property assignment
    Object.assign(this, {
      showPoly: this.show,
      showModalPoly: this.showModal,
      closePoly: this.close,
    })

    // Delete original methods
    delete this.show
    delete this.showModal
    delete this.close
  }

  // Use arrow functions for concise method definitions
  show(...args) {
    return this.showPoly(...args)
  }
  showModal(...args) {
    return this.showModalPoly(...args)
  }
  close(...args) {
    return () => {
      try {
        this.closePoly(...args)
      } catch (error) {
        handleErrorCloseDialogElement(error)
      }
    }
  }

  // Hack for the polyfill
  get localName() {
    return 'dialog'
  }
}

window.HTMLDialogElement = window.HTMLDialogElement || HTMLDialogElement
